(function () {
  function initTextType(el) {
    var texts = JSON.parse(el.getAttribute('data-text-type') || '[]');
    if (!texts.length) return;

    var typingSpeed   = parseInt(el.getAttribute('data-typing-speed')   || '60',   10);
    var deletingSpeed = parseInt(el.getAttribute('data-deleting-speed') || '35',   10);
    var pauseDuration = parseInt(el.getAttribute('data-pause-duration') || '2000', 10);
    var cursorChar    = el.getAttribute('data-cursor') || '|';

    var content = document.createElement('span');
    content.className = 'tt-content';

    var cursor = document.createElement('span');
    cursor.className = 'tt-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.textContent = cursorChar;

    el.appendChild(content);
    el.appendChild(cursor);

    var idx      = 0;
    var charIdx  = 0;
    var deleting = false;
    var current  = '';

    function tick() {
      var target = texts[idx];

      if (deleting) {
        current = current.slice(0, -1);
        content.textContent = current;
        if (current === '') {
          deleting = false;
          idx = (idx + 1) % texts.length;
          charIdx = 0;
          setTimeout(tick, typingSpeed);
        } else {
          setTimeout(tick, deletingSpeed);
        }
      } else {
        if (charIdx < target.length) {
          current += target[charIdx];
          content.textContent = current;
          charIdx++;
          setTimeout(tick, typingSpeed);
        } else {
          setTimeout(function () {
            deleting = true;
            tick();
          }, pauseDuration);
        }
      }
    }

    tick();
  }

  document.querySelectorAll('[data-text-type]').forEach(initTextType);
})();
